var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.469,39.069c-0.78-0.781-2.048-0.781-2.828,0c-2.5,2.5-3.877,5.824-3.877,9.359c0,3.536,1.377,6.859,3.877,9.359 c0.391,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828 c-1.745-1.744-2.705-4.063-2.705-6.531c0-2.467,0.96-4.787,2.705-6.531C42.25,41.117,42.25,39.85,41.469,39.069z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.359,39.069c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828c3.601,3.602,3.601,9.461,0,13.062 c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 C62.521,52.628,62.521,44.23,57.359,39.069z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.572,37c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.048-0.781-2.828,0c-7.861,7.861-7.861,20.652,0,28.513 c0.39,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828 C30.271,53.556,30.271,43.302,36.572,37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.256,34.172c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828c6.302,6.302,6.302,16.555,0,22.857 c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 C70.117,54.824,70.117,42.033,62.256,34.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.364,29.065c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828c9.117,9.118,9.117,23.954,0,33.072 c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 C78.041,57.115,78.041,39.742,67.364,29.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.464,31.893c0.781-0.781,0.781-2.047,0-2.828c-0.78-0.781-2.048-0.781-2.828,0c-10.677,10.677-10.677,28.05,0,38.728 c0.39,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828 C22.347,55.847,22.347,41.011,31.464,31.893z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,43.581c-2.673,0-4.848,2.175-4.848,4.848c0,1.958,1.173,3.639,2.848,4.404v26.444c0,1.104,0.896,2,2,2s2-0.896,2-2 V52.832c1.675-0.764,2.848-2.446,2.848-4.404C52.848,45.756,50.673,43.581,48,43.581z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmit);
export default __webpack_public_path__ + "static/media/transmit.5da98d7d17b352e7b6597c1ec13bf7d2.svg";
export { ForwardRef as ReactComponent };